import { actionTypes } from "../actions/action_types";
import jwt_decode from "jwt-decode";
import history from "../../history";

const initialState = {
  allowedToDisplayDetails: false,
  keycloak: null,
  authenticated: false,
  tokenDetails: null,
};

export default function keycloakReducer(state = initialState, action) {
  var stateCopy = Object.assign({}, state);

  switch (action.type) {
    case actionTypes.APPEND_KEYCLOAK_DETAILS:
      stateCopy = action.payload;
      stateCopy.tokenDetails = jwt_decode(stateCopy.keycloak.token);
      stateCopy.allowedToDisplayDetails = true;
      return stateCopy;

    case actionTypes.ACCOUNT_LOGOUT:
      if (stateCopy.keycloak) {
        stateCopy.keycloak.logout();
        history.push("/");
      }
      return stateCopy;

    default:
      return state;
  }
}
